import * as React from "react";
import {CommonHelpers, resourcesHelper} from "@falcon/services";

export class SportsPassBanner extends React.Component {


    public render() {
        const showDate = process.env.REACT_APP_SPORTS_PASS_BANNER_SHOW_DATE;
        const hideDate = process.env.REACT_APP_SPORTS_PASS_BANNER_HIDE_DATE;

        const sportsPassFromDate = showDate ? CommonHelpers.getDate(showDate) : undefined;
        const sportsPassToDate = hideDate ? CommonHelpers.getDate(hideDate) : undefined;
        const today = new Date();

        const showBanner = (sportsPassFromDate === undefined) ? false :
            (today >= sportsPassFromDate && (sportsPassToDate === undefined || today <= sportsPassToDate));

        return (
            showBanner ? <div className="banner banner-content">
                    <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                    <div className="banner-text">
                        Visit the customer offers page to claim your free 3-month SportsPass, plus lots more offers!
                        It's all part of being an {resourcesHelper.THEME} customer. T&C's apply.
                        <p className="mt-3">
                            <a href="https://www.allianz.co.uk/insurance/car-insurance/customer-offers.html">&rarr; See
                                offers</a>
                        </p>
                    </div>
            </div> : <></>
        )
    }
}
